import numberFormatter from 'utils/formatNumber';
import { CombinedAudiencePlatformLabel } from '../../constants/index';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  subText: {
    color: '#685d6f',
    fontSize: 12,
    marginRight: 5,
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: 'Calibre-Regular,sans-serif',
    fontSize: 16,
    marginTop: '1px',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'end',
    gap: 4,
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
}));

const RenderEstimatedAudienceSize = ({ lalAudienceCount }) => {
  const classes = useStyles();
  if (!lalAudienceCount || !lalAudienceCount?.length === 0) {
    return null;
  }

  return (
    <div>
      {CombinedAudiencePlatformLabel.map(item => {
        const audienceCount = lalAudienceCount?.find(
          a => a.idType === item.TYPE
        )?.audienceCount;
        const lowerBoundRange = audienceCount
          ? Math.round(audienceCount * 0.9)
          : 0;
        const upperBoundRange = audienceCount
          ? Math.round(audienceCount * 1.1)
          : 0;
        return (
          <div key={item.PRIMARY_TEXT} className={classes.listItemContainer}>
            <div className={classes.leftSection}>
              <b>{item.PRIMARY_TEXT}</b>
              <span className={classes.subText}>{item.SECONDARY_TEXT}</span>
            </div>
            <div className={classes.rightSection}>
              {numberFormatter(lowerBoundRange, 1)}
              {'  -  '}
              {numberFormatter(upperBoundRange, 1)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RenderEstimatedAudienceSize;
